export const CREATE_BUSINESS_REQUEST = '[CustomerCard] Create Business Request';
export const CREATE_BUSINESS_SUCCESS = '[CustomerCard] Create Business Success';
export const CREATE_BUSINESS_FAILURE = '[CustomerCard] Create Business Failure';
export const ASSOCIATE_BUSINESS_REQUEST = '[CustomerCard] Associate Business Request';
export const ASSOCIATE_BUSINESS_SUCCESS = '[CustomerCard] Associate Business Success';
export const ASSOCIATE_BUSINESS_FAILURE = '[CustomerCard] Associate Business Failure';
